import { Injectable } from '@angular/core';
import {environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EncrDecrService } from '../../services/encr-decr.service';


@Injectable({
  providedIn: 'root'
})
export class AllEventsService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { } 

  getAllEvents() {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'admin/events/all', {'country': ''},{headers: headers_object}).toPromise()
  }

}
